/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B000200 商品照会
 */
import { Column, Query } from "@material-table/core";
import {
  B000111SakaNm,
  B000200Find,
  B000200FindRequest,
  catchRestError,
} from "clients/rest";
import { Box } from "@mui/material";
import {
  SText,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  STextField,
  msgState,
} from "components";
import { labels } from "messages/labels";
import { createRef, useContext, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { mapIds } from "services";
import { focusState, SDialogContext, useFocus } from "states";
import { B000111, B000202 } from "pages";
import { useNavigate } from "react-router-dom";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 削除予定区分チェック除外区分
  deljogaiKbn: string;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  shohinCdFrom: string;
  shohinCdTo: string;
  janCdFrom: string;
  janCdTo: string;
  name: string;
  sakaCd: string;
  sakaNm: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  // 削除予定区分チェック除外区分(1の場合、削除予定区分を無視)
  deljogaiKbn: string;
}>;

// テーブル定義
type Data = Partial<{
  gyoNo: number;
  shohinCd: string;
  shohinNm: string;
  shohinKana: string;
  sakaNm: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  janCd: string;
  shohinNmr: string;
  vol: string;
  sakaCd: string;
  shokuchiKbn: number;
  kazeiKbn: number;
  tankaKbn: number;
  whtankaCd: string;
  whgenyankaCd: string;
  shireCd: string;
  itfCd: string;
  setshohinKbn: number;
  shohinshubetsuKbn: number;
  urikiriKbn: number;
  zairyoshohinCd: string;
  tashisun: number;
  loss2: number;
  sunpo: number;
  sotosunW: number;
  sotosunH: number;
  uchisunW: number;
  uchisunH: number;
  kakoshubetsuCd: string;
  shiyo1: string;
  shiyo2: string;
  shiyo3: string;
  zaikokanriKbn: number;
  zaikohikiateKbn: number;
  minuszaikocheckKbn: number;
  shobunCd1: string;
  shobunCd2: string;
  shobunCd3: string;
  shobunCd4: string;
  shobunCd5: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  sakujoyoteiKbn: number;
  chohyoBunruiCd1: string;
  chohyoBunruiCd2: string;
  chohyoBunruiCd3: string;
  chohyoBunruiCd4: string;
  chohyoBunruiCd5: string;
  chohyoBunruiCd6: string;
  chohyoBunruiCd7: string;
  chohyoBunruiCd8: string;
  chohyoBunruiCd9: string;
  chohyoBunruiCd10: string;
  chohyoBunruiCd11: string;
  chohyoBunruiCd12: string;
  chohyoBunruiCd13: string;
  chohyoBunruiCd14: string;
  chohyoBunruiCd15: string;
  version: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  shohinCdFrom: "",
  shohinCdTo: "",
  janCdFrom: "",
  janCdTo: "",
  name: "",
  sakaCd: "",
  sakaNm: "",
  shodaibun: "",
  shochubun: "",
  shoshobun: "",
};

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "2rem", align: "right" },
  { field: "shohinCd", title: "商品コード", width: "15rem" },
  { field: "shohinNm", title: "商品名", width: "20rem" },
  { field: "shohinKana", title: "商品名カナ", width: "20rem" },
  { field: "sakaNm", title: "作家名", width: "15rem" },
  { field: "shodaibun", title: "大分類", width: "10rem" },
  { field: "shochubun", title: "中分類", width: "10rem" },
  { field: "shoshobun", title: "小分類", width: "10rem" },
  { field: "janCd", title: "JANコード", width: "15rem" },
  { field: "shohinNmr", hidden: true },
  { field: "vol", hidden: true },
  { field: "sakaCd", hidden: true },
  { field: "shokuchiKbn", hidden: true },
  { field: "kazeiKbn", hidden: true },
  { field: "tankaKbn", hidden: true },
  { field: "whtankaCd", hidden: true },
  { field: "whgenyankaCd", hidden: true },
  { field: "shireCd", hidden: true },
  { field: "itfCd", hidden: true },
  { field: "setshohinKbn", hidden: true },
  { field: "shohinshubetsuKbn", hidden: true },
  { field: "urikiriKbn", hidden: true },
  { field: "zairyoshohinCd", hidden: true },
  { field: "tashisun", hidden: true },
  { field: "loss2", hidden: true },
  { field: "sunpo", hidden: true },
  { field: "sotosunW", hidden: true },
  { field: "sotosunH", hidden: true },
  { field: "uchisunW", hidden: true },
  { field: "uchisunH", hidden: true },
  { field: "kakoshubetsuCd", hidden: true },
  { field: "shiyo1", hidden: true },
  { field: "shiyo2", hidden: true },
  { field: "shiyo3", hidden: true },
  { field: "zaikokanriKbn", hidden: true },
  { field: "zaikohikiateKbn", hidden: true },
  { field: "minuszaikocheckKbn", hidden: true },
  { field: "shobunCd1", hidden: true },
  { field: "shobunCd2", hidden: true },
  { field: "shobunCd3", hidden: true },
  { field: "shobunCd4", hidden: true },
  { field: "shobunCd5", hidden: true },
  { field: "torihikikaishiYmd", hidden: true },
  { field: "torihikishuryoYmd", hidden: true },
  { field: "sakujoyoteiKbn", hidden: true },
  { field: "chohyoBunruiCd1", hidden: true },
  { field: "chohyoBunruiCd2", hidden: true },
  { field: "chohyoBunruiCd3", hidden: true },
  { field: "chohyoBunruiCd4", hidden: true },
  { field: "chohyoBunruiCd5", hidden: true },
  { field: "chohyoBunruiCd6", hidden: true },
  { field: "chohyoBunruiCd7", hidden: true },
  { field: "chohyoBunruiCd8", hidden: true },
  { field: "chohyoBunruiCd9", hidden: true },
  { field: "chohyoBunruiCd10", hidden: true },
  { field: "chohyoBunruiCd11", hidden: true },
  { field: "chohyoBunruiCd12", hidden: true },
  { field: "chohyoBunruiCd13", hidden: true },
  { field: "chohyoBunruiCd14", hidden: true },
  { field: "chohyoBunruiCd15", hidden: true },
  { field: "version", hidden: true },
];

// フォーカスIDの設定
const focusId = "B000200";

//B000200 商品照会
export const B000200 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};
const Page = (props: Props) => {
  // 状態管理の初期設定
  // テーブルの値取得用Ref
  const tableRef = createRef();
  // 初回検索用のフラグ
  const [searched, setSearched] = useState(false);
  // 検索ボタン押下時に初期ページにするRef
  const isDefaultPage = useRef(false);
  // ダイアログで処理を行う関数
  const handleSubmit = useContext(SDialogContext);
  //フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // フォーカス関数
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 画面遷移
  const navigate = useNavigate();

  //初期表示
  useEffect(() => {
    // 削除予定区分チェック除外区分処理
    if (props.deljogaiKbn) {
      methods.setValue("deljogaiKbn", props.deljogaiKbn);
    }
    focus(1);
  }, []);

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 検索可能に変更
    setSearched(true);
    // 初期ページ設定
    isDefaultPage.current = true;
    // テーブル再検索
    (tableRef.current as any).onQueryChange();
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (data: Data) => {
    handleSubmit(data);
  };

  // 検索イベント
  const handleSearch = (query: Query<Data>) => {
    return new Promise<any>((resolve) => {
      // 初回検索をしない
      if (!searched) {
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }
      // 検索フォームのデータを取得する。
      const fields = methods.getValues();
      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;
      // 検索パラメータを作成する。
      const param: B000200FindRequest = {
        shohinCdFrom: fields.shohinCdFrom,
        shohinCdTo: fields.shohinCdTo,
        janCdFrom: fields.janCdFrom,
        janCdTo: fields.janCdTo,
        name: fields.name,
        sakaCd: fields.sakaCd,
        shodaibun: fields.shodaibun,
        shochubun: fields.shochubun,
        shoshobun: fields.shoshobun,
        // 削除予定区分チェック除外区分
        deljogaiKbn: fields.deljogaiKbn,
        // ページネーションの設定
        page: query.page,
        size: query.pageSize,
        // ソートの設定
        sort: ["shohinCd,asc"],
      };
      // API呼び出し
      B000200Find(param)
        // 正常取得時
        .then((value) => {
          const offset = query.pageSize * query.page;
          resolve({
            data: mapIds(value.data.content, "gyoNo", offset),
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
        })
        // エラー時
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="商品照会"
        gridTemplateColumns="6rem 6rem 1rem 6rem 6rem 6rem 3rem 3rem 1rem 2rem 2rem 2rem 2rem"
      >
        <SLabel>商品コード</SLabel>
        <SNumberField name="shohinCdFrom" code size={10} {...register(1)} />
        <SText>～</SText>
        <SNumberField name="shohinCdTo" code size={10} {...register(2)} />

        <Box />

        <SLabel>JANコード</SLabel>
        <SNumberField
          name="janCdFrom"
          code
          size={13}
          {...register(3)}
          gridColumn="span 2"
        />
        <SText>～</SText>
        <SNumberField
          name="janCdTo"
          code
          size={13}
          {...register(4)}
          gridColumn="span 3"
        />
        <SLabel gridColumn="1">商品名</SLabel>
        <STextField
          name="name"
          size={40}
          gridColumn="span 3"
          {...register(5)}
        />
        <SLabel gridColumn={6}>作家名</SLabel>
        <SNumberField
          name="sakaCd"
          code
          size={3}
          {...register(6)}
          gridColumn="span 2"
          onBlur={() => B000111SakaNm(methods, navigate, setMsg)}
          dialog={<B000111 meishoKbn="37" />}
          handleSubmit={(data: any) => {
            methods.setValue("sakaCd", data.meishoCd);
          }}
        />
        <STextField name="sakaNm" size={40} disabled gridColumn="span 4" />
        <Box gridRow={3} gridColumn="span 4" />
        <SLabel gridRow={3} gridColumn={6}>
          商品分類
        </SLabel>
        <SNumberField
          name="shodaibun"
          code
          size={3}
          {...register(7)}
          gridRow={3}
          gridColumn={7}
        />
        <SNumberField
          name="shochubun"
          code
          size={3}
          {...register(8)}
          gridRow={3}
          gridColumn={8}
        />
        <SNumberField
          name="shoshobun"
          code
          size={3}
          {...register(9)}
          gridRow={3}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            methods.setValue("shodaibun", data.shodaibunCd);
            methods.setValue("shochubun", data.shochubunCd);
            methods.setValue("shoshobun", data.shoshobunCd);
          }}
          gridColumn="span 3"
        />
        <SNormalButton
          label={labels.buttons.search}
          gridRow="4"
          gridColumn="13"
          {...register(10)}
          onClick={handleClickSearchButton}
        />
      </SFrame>
      <SFrame>
        <STable
          keyName="gyoNo"
          data={handleSearch}
          columns={columns}
          tableRef={tableRef}
          handleDoubleClick={handleDoubleClickTableRow}
        />
      </SFrame>
    </FormProvider>
  );
};
